/**
 * @file: 画布矩阵变换
 * @author: xiaolong.huang@dmall.com
 */

import * as Toolkit from '../../toolkit';
import Config from '../../config';
import Utils from '../../utils/util';

class Matrix {
    stageDom: any = null;
    transformDom: any = null;
    $mask: any = null;
    $config: FreeObjMap = {};
    stageRect: FreeObjMap = {};
    maskLoad: boolean = false;
    moveStart: any = null;
    $oldPos: any = null;
    initialWidth: number = -1;
    initialHeight: number = -1;

    constructor(stageDom, transformDom, config) {
        this.stageDom = stageDom;
        this.transformDom = transformDom;
        this.$config = Utils.deepCopy(config);
        this.transformDom.css({
            transform: 'matrix(1, 0, 0, 1, 0, 0)'
        });
        this.$mask = $('#shelvesbuild-e-sketchpad__zoom-mask');
        this.matrixTo();
        this.lastPos();
    }

    private matrixTo() {
        var self = this;

        self.transformDom.css({
            transform: Toolkit.createMatrix(
                {
                    x: self.$config.scale,
                    y: self.$config.scale
                },
                {
                    x: self.$config.x,
                    y: self.$config.y
                }
            )
        });
    }

    private zoom(params) {
        var self = this;
        var evtDom = self.stageDom[0];
        var lastScale = self.$config.scale;
        var scale;

        if (params.type === 'zoomIn') {
            // 缩小
            scale = Utils.numberZoomIn(lastScale, self.$config.speed);
        }
        else {
            // 放大
            scale = Utils.numberZoomOut(lastScale, self.$config.speed);
        }

        this.zoomTo(scale, {
            left: params.left,
            top: params.top
        });
        return true;
    }

    private zoomTo(scale: number, point: MousePoint): void {
        var self = this;

        if (this.initialWidth < 0) {
            let transformDomRect = this.getRect(this.transformDom.get(0));
            let stageDomRect = this.getRect(this.stageDom.get(0));

            this.initialWidth = transformDomRect.width;
            this.initialHeight = transformDomRect.height;
            this.$config.width = this.initialWidth;
            this.$config.height = this.initialHeight;
            this.stageRect.left = stageDomRect.left;
            this.stageRect.top = stageDomRect.top;
        }

        let relativeLeft = Utils.math(Utils.math(point.left, self.$config.x, '-'), this.stageRect.left, '-');
        let relativeTop = Utils.math(Utils.math(point.top, self.$config.y, '-'), this.stageRect.top, '-');
        let leftProportion = Utils.math(relativeLeft, this.$config.width, '/');
        let topProportion = Utils.math(relativeTop, this.$config.height, '/');
        let disWidth = Utils.math(this.$config.width, Utils.math(this.initialWidth, scale, '*'), '-');
        let disHeight = Utils.math(this.$config.height, Utils.math(this.initialHeight, scale, '*'), '-');
        let disLeft = Utils.math(disWidth, leftProportion, '*');
        let disTop = Utils.math(disHeight, topProportion, '*');

        self.$config.x = Utils.math(self.$config.x, disLeft, '+');
        self.$config.y = Utils.math(self.$config.y, disTop, '+');
        self.$config.width = Utils.math(this.initialWidth, scale, '*');
        self.$config.height = Utils.math(this.initialHeight, scale, '*');
        self.$config.scale = scale;
        self.matrixTo();
        self.lastPos();
    }

    private middle(left: number, size: number): number {
        let sizeHalf: number = Utils.math(size, 2, '/');

        return Utils.math(left, sizeHalf, '+');
    }

    transformData(): FreeObjMap {
        return {
            ...this.$config
        }
    }

    getRect(dom) {
        return dom.getBoundingClientRect();
    }

    zoomIn(point) {
        this.zoom({
            type: 'zoomIn',
            left: point.left,
            top: point.top
        });
    }

    zoomOut(point) {
        this.zoom({
            type: 'zoomOut',
            left: point.left,
            top: point.top
        });
    }

    move(e) {
        var self = this;

        if (!self.moveStart) {
            return;
        }

        let disX: number = Utils.math(e.clientX, self.moveStart.clientX, '-');
        let disY: number = Utils.math(e.clientY, self.moveStart.clientY, '-');
        let x: number = Utils.math(self.$oldPos.x, disX, '+');
        let y: number = Utils.math(self.$oldPos.y, disY, '+');

        self.$config.x = x;
        self.$config.y = y;
        this.matrixTo();

        // todo: 把 this.lastPos(); 移动到这里
    }

    moveTo(codi: LogicPosition): void {
        this.$config.x = codi.left;
        this.$config.y = codi.top;
        this.matrixTo();
        this.lastPos();
    }

    addMask(e) {
        var self = this;

        if (self.maskLoad) {
            return;
        }
        this.$mask.addClass('show');
        self.maskLoad = true;
    }

    removeMask() {
        var self = this;

        this.$mask.removeClass('show');
        while (this.$mask.hasClass('show')) {
            this.$mask.removeClass('show');
        }
        setTimeout(() => {
            this.$mask.removeClass('show');
        }, 10);
        self.maskLoad = false;
    }

    getStartPos(e) {
        this.moveStart = e;
    }

    lastPos() {
        var old = this.transformDom.css('transform').replace(/^matrix(3d)?\((.*)\)$/, '$2').split(/, /);

        this.$oldPos = {
            x: parseFloat(old[4]),
            y: parseFloat(old[5]),
            scale: parseFloat(old[0])
        };
        this.moveStart = null;
    }
}

export default Matrix;
